export const FACILITY_TYPES = [
  {
    value: 'elderly',
    abbr: 'RCFE',
    name: 'Residential Care Facility for the Elderly',
    description: 'Non-medical care for persons 60+',
  },
  {
    value: 'adult',
    abbr: 'ARF',
    name: 'Adult Residential Facility',
    description: '24-hour non-medical care for adults 18–59',
  },
  {
    value: 'group',
    abbr: 'GH',
    name: 'Group Home',
    description: '24-hour non-medical care for children',
  },
  {
    value: 'short_term',
    abbr: 'STRTP',
    name: 'Short-Term Residential Therapeutic Program',
    description: 'Intensive treatment for children & youth',
  },
];
